import * as R from 'ramda'
import { combineReducers } from 'redux'

import { UPDATE_SELECTED_CUSTOMER } from '../../actions/'

import customersReducer from './customer'
import dashboardReducer from './dashboard'
import feedbackReducer from './feedback'
import loginReducer from './login'
import signupReducer from './signup'
import ticketSatisfactionReducer from './ticketSatisfaction'
import integrationsReducer from './integrations'
import resetPassword from './resetPassword'
import surveysReducer from './surveys'

/**
 *
 * @param {object} state
 * @param {object} action
 * @param {string} action.type
 * @param {string} action.page
 * @param {string} action.customerEmail
 * @returns
 */
const partialPagesReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_SELECTED_CUSTOMER: {
      if (!(action.page in state)) {
        return state
      }
      return {
        [action.page]: { selectedCustomer: action.customerEmail },
      }
    }
    default:
      return {}
  }
}

const combinedReducers = combineReducers({
  customers: customersReducer,
  dashboard: dashboardReducer,
  feedback: feedbackReducer,
  login: loginReducer,
  signup: signupReducer,
  ticketSatisfaction: ticketSatisfactionReducer,
  integrations: integrationsReducer,
  resetPassword: resetPassword,
  surveys: surveysReducer,
})

const pagesReducer = (state, action) =>
  R.mergeDeepRight(combinedReducers(state, action), partialPagesReducer(state, action))

export default pagesReducer



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/pages/index.js